<tds-modal size="md" closeIconButtonLabel="Close">
  <tds-modal-title>New analyst</tds-modal-title>
  <div class="analyst-form">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <mat-select [value]="selectedUserId()" (selectionChange)="onUserChange($event.value)">
        <mat-option [value]="undefined">None</mat-option>
        @for (user of users(); track user.id) {
          <mat-option [value]="user.id">{{ userLabel(user) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (userError()) {
      <span class="analyst-error">Select an email.</span>
    }

    <div class="analyst-field">
      <label class="analyst-field-label" for="analyst-first-name">First name</label>
      <input
        id="analyst-first-name"
        type="text"
        class="analyst-input"
        placeholder="John"
        [value]="firstName()"
        (input)="onFirstNameChange($event)"
      />
    </div>
    <div class="analyst-field">
      <label class="analyst-field-label" for="analyst-last-name">Last name</label>
      <input
        id="analyst-last-name"
        type="text"
        class="analyst-input"
        placeholder="Doe"
        [value]="lastName()"
        (input)="onLastNameChange($event)"
      />
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Zones</mat-label>
      <mat-select multiple [value]="selectedZoneIds()" (selectionChange)="onZonesChange($event.value)">
        @for (zone of regionsViewModel().regions; track zone.id) {
          <mat-option [value]="zone.id">{{ zoneLabel(zone) }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <tds-modal-actions>
    <button tds-button variant="tertiary" (click)="close()">Cancel</button>
    <button tds-button (click)="save()">Save</button>
  </tds-modal-actions>
</tds-modal>
